const APPLICATION_HOSTNAMES = new Set([
  'portal.soomuch.ai',
  'portal-dev.soomuch.ai',
  'smdev.soomuch.ai',
]);

const LOCAL_APPLICATION_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

export type HostContext =
  | { type: 'application'; schoolSubdomain: null }
  | { type: 'school'; schoolSubdomain: string };

function normalizeHostname(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/\.$/, '').split(':')[0];
}

export function classifyHostname(hostname: string): HostContext {
  const normalizedHostname = normalizeHostname(hostname);

  if (
    !normalizedHostname ||
    LOCAL_APPLICATION_HOSTNAMES.has(normalizedHostname) ||
    APPLICATION_HOSTNAMES.has(normalizedHostname)
  ) {
    return { type: 'application', schoolSubdomain: null };
  }

  const hostnameParts = normalizedHostname.split('.');
  const isSoomuchSchoolHostname =
    hostnameParts.length === 3 &&
    hostnameParts[1] === 'soomuch' &&
    hostnameParts[2] === 'ai';

  if (isSoomuchSchoolHostname) {
    return { type: 'school', schoolSubdomain: hostnameParts[0] };
  }

  return { type: 'application', schoolSubdomain: null };
}

export function getCurrentHostContext(): HostContext {
  return classifyHostname(window.location.hostname);
}
